import apiService from '../../../services/api'

/**
 * UZS Withdraw API
 * Сервис для вывода кристаллов на узбекскую карту
 * Документация: docs/uzs_withdraw.md (гайд для фронтенда)
 *
 * Два эндпоинта:
 * - GET /api/uzs-withdraw/ — всё для экрана (info + history)
 * - POST /api/uzs-withdraw/ — создать заявку на вывод
 */

/**
 * Получить данные экрана вывода: info + история заявок
 * @returns {Promise<Object>} { info: {...}, history: [...] }
 */
export const createCardWithdrawApi = (currency) => ({
  fetchData: () => apiService.makeRequest(`/api/${currency}-withdraw/`, { parseForbidden: true }),
  create: ({ card_number, card_owner, bank_name, crystals }) => apiService.makeRequest(`/api/${currency}-withdraw/`, {
    method: 'POST',
    parseForbidden: true,
    body: JSON.stringify({ card_number, card_owner, ...(currency === 'uzs' ? { bank_name } : {}), crystals }),
  }),
})

const cardApi = createCardWithdrawApi('uzs')

const fetchUzsWithdrawData = () => cardApi.fetchData()

/**
 * Создать заявку на вывод кристаллов в UZS
 * @param {Object} params — реквизиты и сумма
 * @param {string} params.card_number — номер карты (16–19 цифр, пробелы/дефисы допустимы)
 * @param {string} params.card_owner — ФИО получателя (минимум два слова)
 * @param {string} params.bank_name — банк получателя
 * @param {number} params.crystals — сумма в кристаллах
 * @returns {Promise<Object>} { id, uzs, crystals, status }
 */
const createUzsWithdraw = (params) => cardApi.create(params)

export default {
  fetchUzsWithdrawData,
  createUzsWithdraw,
}
